<div [formGroup]="form">
  <section class="insurance-period">
    <h4 id="{{ baseId }}-period-subtitle" class="insurance-title" translate>Insurance Period</h4>

    <div class="button-plus-new">
      <button
        id="fnd-configuration-new"
        class="btn btn-light btn-flush-left "
        (click)="onNewClick()"
        translate
        type="button"
      >
        + New
      </button>
    </div>

    <table class="table emds-table table-sticky-header insurance-table table-striped table-selected-row">
      <thead>
      <tr>
        <th>Effective Date</th>
        <th>Expiration Date</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let formGroupRow of workerCompFormArray.controls; index as idx"
          [class.selected]="idx === selectedIndex"
          (click)="choseTableItem(idx)"
      >
        <td>{{ formGroupRow.value.EffectiveDate | date: 'M/d/YYYY' }}</td>
        <td>{{ formGroupRow.value.ExpirationDate ? (formGroupRow.value.ExpirationDate | date: 'M/d/YYYY') : 'None' }}</td>
        <td>
          <div class="emds icons-container">
            <a role="button" title="edit" (click)="onEditTableItem($event, formGroupRow.value)">
              <mat-icon class="material-icons">edit</mat-icon>
            </a>
            <a role="button" title="delete" (click)="onDeleteTableItem($event, idx)">
              <mat-icon class="material-icons">delete</mat-icon>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </section>

  <div class="form-group flex-item-three-columns">
    <ng-container *ngIf="showRowDetails">
      <label for="{{ baseId }}-payer-findcontrol" translate>Insurance Plan</label>
      <ng-container *ngIf="selectedIndex | isNil">
        <ap-findcontrol id="{{ baseId }}-id-insurance-plan-findcontrol"
        baseId="{{ baseId }}-insurance-plan-findcontrol"
        [disabled]="true"
        >
        </ap-findcontrol>
      </ng-container>
      <ng-container *ngIf="selectedIndex | isNotNil">
        <ap-findcontrol id="{{ baseId }}-id-insurance-plan-findcontrol"
                        baseId="{{ baseId }}-insurance-plan-findcontrol"
                        controlName="InsurancePlan"
                        findControlDisplayName="Find Insurance Plan"
                        [form]="form"
                        [disabled]="!workerCompFormArray.value.length"
                        [apFormGroup]="selectedFormGroup"
                        [findControlId]="FindControlIdService.ViewPayerPlan"
                        [singleSelect]="true"
                        [required]="getFindControlValidation('InsurancePlanUid')"
                        [selectedPks]="getWorkerCompControl(selectedIndex, 'InsurancePlan').value"
                        (chipsChange)="onInsurancePlanDataPopulate($event)"
                        (dirty)="getWorkerCompControl(selectedIndex, 'InsurancePlan').markAsDirty()">
        </ap-findcontrol>
      </ng-container>
    </ng-container>
  </div>

  <section class="address">
    <h4 id="{{ baseId }}-address-subtitle" translate>Address</h4>
    <fc-address-list
      [form]="addressGroup"
      [baseId]="baseId + 'address'"
      [listItem]="addressListItem"
      [isSubmitted]="isSubmitted"
      [isFullAddress]="false"
      [itemContext]="itemContext"
      [disableControls]="disableAddressListControls"
    >
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-phone-number">Phone</label>
        <input
          disabled
          id="{{ baseId }}-phone-number"
          type="text"
          class="form-control"
          [value]="selectedFormGroup.get('phoneAddress')?.value ?? ''"
        />
      </div>
    </fc-address-list>

  </section>

  <div class="form-group flex-item-three-columns">
    <ng-container *ngIf="showRowDetails">
      <label for="{{ baseId }}-payer-findcontrol" translate>Insurance Contact</label>
      <ng-container *ngIf="selectedIndex | isNil">
        <ap-findcontrol id="{{ baseId }}-id-insurance-plan-findcontrol"
                        baseId="{{ baseId }}-insurance-plan-findcontrol"
                        [disabled]="true"
        >
        </ap-findcontrol>
      </ng-container>
      <ng-container *ngIf="selectedIndex | isNotNil">
        <ap-findcontrol id="{{ baseId }}-insurance-contact-findcontrol"
                        baseId="{{ baseId }}-insurance-contact-findcontrol"
                        controlName="InsuranceContact"
                        findControlDisplayName="Find Insurance Contact"
                        [form]="form"
                        [disabled]="!workerCompFormArray.value.length"
                        [apFormGroup]="selectedFormGroup"
                        [findControlId]="FindControlIdService.ViewInsurancePayerContact"
                        [singleSelect]="true"
                        [required]="getFindControlValidation('InsuranceContact')"
                        [selectedPks]="getWorkerCompControl(selectedIndex, 'InsuranceContact').value"
                        (chipsChange)="onInsuranceContactDataPopulate($event)"
                        (dirty)="getWorkerCompControl(selectedIndex, 'InsuranceContact').markAsDirty()">
        </ap-findcontrol>
      </ng-container>
    </ng-container>
  </div>

  <section class="contact-information">
    <h4 id="{{ baseId }}-contact-information-subtitle" translate>Contact Information</h4>

    <div class="flex-row-generic">
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-phone-number">Phone</label>
        <input
          disabled
          id="{{ baseId }}-phone-number"
          type="text"
          class="form-control"
          [value]="selectedFormGroup.get('InsuranceContactData')?.value?.phoneNumber ?? ''"
        />
      </div>
      <!-- Email 1 Control -->
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-email-one" translate>Email 1</label>
        <input
          disabled
          [value]="selectedFormGroup.get('InsuranceContactData')?.value?.email1 ?? ''"
          id="{{ baseId }}-email-one"
          class="form-control"
          type="text"
        />
      </div>
      <!-- Email 1 Control -->

      <!-- Email 2 Control -->
      <div class="form-group flex-item-three-columns">
        <label for="{{ baseId }}-email-two" translate>Email 2</label>
        <input
          disabled
          id="{{ baseId }}-email-two"
          class="form-control"
          type="text"
          [value]="selectedFormGroup.get('InsuranceContactData')?.value?.email2 ?? ''"
        />
      </div>
      <!-- Email 2 Control -->
    </div>
  </section>


</div>
